exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list[data-v-05f57e76] {\n    height: 32px;\n    background-color: #fafafa;\n    border: 1px solid #fafafa;\n    margin-bottom: 10px;\n    border-radius: 4px;\n    padding: 0 8px;\n}\n.list_editing[data-v-05f57e76] {\n    margin-bottom: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05f57e76","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/TextList.vue
// module id = NUam
// module chunks = 142